:host {
  position: fixed;
  inset: 0;
  z-index: 100000;
  display: block;
  font-family: var(--sl-font-sans);
}

.overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--agwa-overlay);
  backdrop-filter: blur(2px);
}

.card {
  width: 100%;
  max-width: 26rem;
  padding: 1.75rem 1.5rem;
  text-align: center;
  background: var(--agwa-surface-raised);
  border-radius: var(--sl-border-radius-large);
  border-top: 4px solid var(--agwa-accent);
  box-shadow: var(--sl-shadow-x-large);
}

.icon {
  font-size: 2.25rem;
  color: var(--agwa-accent-text);
}

.title {
  margin: 0.5rem 0 0.4rem;
  font-weight: var(--sl-font-weight-semibold);
  font-size: var(--sl-font-size-large);
  color: var(--agwa-text);
}

.body {
  margin-bottom: 1.35rem;
  color: var(--agwa-text);
  font-size: var(--sl-font-size-medium);
  line-height: 1.5;
}

.actions {
  display: flex;
  justify-content: center;
}

.hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  margin-top: 1.1rem;
  color: var(--agwa-text-muted);
  font-size: var(--sl-font-size-small);
  line-height: 1.5;
}

.hint kbd {
  white-space: nowrap;
  font-family: var(--sl-font-mono);
  font-size: var(--sl-font-size-large);
  font-weight: var(--sl-font-weight-semibold);
  padding: 0.35rem 0.75rem;
  color: var(--agwa-text);
  background: var(--agwa-surface-sunken);
  border: 1px solid var(--agwa-border-strong);
  border-radius: 5px;
}
